import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import CustomAccordion from "../../../../../../components/accordion"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { useState } from "react"
import { CommentProps } from "./types"
import { CommentDetail } from "../commentDetail"
import { useMutation } from "@tanstack/react-query"
import { scheduleServiceFetch } from "../../../../../../utils/constants/callService"
import { emitEvent } from "../../../../../../hooks/emitter"
import { Events } from "../../../../../../hooks/emitter/types"
import { InputComment } from "../inputComment"
import { Types } from "../../../../../../utils/enums"
import { useTranslation } from "react-i18next"
import { useEvidences } from "../../../../../../hooks/evidences/useEvidences"
import EvidenceDetail from "../../../../../actionPlans/pages/form/components/evidenceDetail"
import { ActionDrawer } from "../../../../../../components/ActionDrawer"
import { useAccordions, useEvidenceDownload } from "../../../detail/hooks/index"
import { SnackSimple } from "../../../../../../components"

const Comment = ({ comment, notAddComment, existed, evidence }: CommentProps) => {
    const { evidences, existEvidences, } = useEvidences({ evidencesResponse: evidence || [] })
    const { t } = useTranslation()
    const styles = useStyles()
    const [expand, setExpand] = useState(false)
    const [addComent, setAddComent] = useState(false)
    const [value, setComment] = useState<null | string>(null)
    const { isPending, mutate } = useMutation({
        mutationFn: scheduleServiceFetch.createComment,
        onSuccess: () => {
            setAddComent(false)
            setComment(null)
            emitEvent(Events.comment, undefined)
            emitEvent(Events.snackbar, { open: true, type: Types.SUCCESS, message: t('general.commentMessage.success') })
        },
        onError: () => {
            emitEvent(Events.snackbar, { open: true, type: Types.ERROR, message: t('general.commentMessage.error') })
        }
    })
    const displayComment = ({ value }: { value: boolean }) => {
        setAddComent(value)
        setComment(null)
    }

    const sendComment = async ({ idChild }: { idChild: string }) => {
        if (!value) { return }

        mutate({ body: { comment: value, recurrenceCommentId: existed ? null : idChild, recurrenceId: existed ? idChild : null } })
    }
    const expandAccordion = () => {
        setExpand(!expand)
    }

    const { disable, openSnackbar, handleCloseSnackbar, downloadEvidences } = useEvidenceDownload('evidencias de reincidencia',evidence);

    return (

        <ActionDrawer
            title="EVIDENCIAS"
            body={<>
                <Box sx={styles.mainContainer}>
                        <EvidenceDetail
                            existEvidences={existEvidences}
                            evidences={{
                                image: evidences?.images,
                                comment: evidences?.comments,
                                documents: evidences?.documents,
                                video: evidences?.video,
                            }}
                        />
                    <Box>
                        <Button variant='text_primary' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                </Box>
                </>}
        >
            {
                ({ openDrawer }) => (<>
                    <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
                    <CustomAccordion
                        expanded={expand}
                        expandIcon={null}
                        accordionProps={{ sx: styles.accordion }}
                        title={(
                            <Box sx={styles.titleContainer}>
                                <Typography variant="subtitle_grey" sx={styles.amount}>{comment.amount}</Typography>

                                <Box sx={styles.info}>
                                    <Typography variant="text_grey" fontWeight='500'>{comment.label}</Typography>

                                    <Box sx={styles.right}>
                                        <Box sx={styles.date}>
                                            <Typography variant="text_grey">{comment.date}</Typography>

                                            <Typography className="max-content" variant="text_grey">{comment.user}</Typography>
                                        </Box>

                                        <Box sx={styles.actions}>
                                            {!!existEvidences && (<>
                                                <Tooltip title={t('general.seeEvidence')}>
                                                    <IconButton sx={styles.see} onClick={openDrawer}>
                                                        {icons('clip')}
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title={t('schedule.buttons.download')}>
                                                    <IconButton onClick={downloadEvidences} disabled={disable}>
                                                        {icons('download')}
                                                    </IconButton>
                                                </Tooltip>
                                                </>)}

                                            {!notAddComment && 
                                                <Tooltip title={t(addComent ? t('schedule.buttons.cancelComment') : t('schedule.buttons.sendComment'))}>
                                                    <IconButton onClick={() => { displayComment({ value: !addComent }) }} className="color-primary">{icons(addComent ? 'cancel-message' : 'send')}</IconButton>
                                                </Tooltip>
                                            }


                                            <IconButton disabled={comment?.comments?.length===0} sx={styles.rotate(expand)} onClick={expandAccordion}>{icons('arrow-down')}</IconButton>
                                        </Box>
                                    </Box>
                                </Box>

                                {
                                    !notAddComment && (
                                        <InputComment
                                            comment={value}
                                            isPending={isPending}
                                            show={!!addComent}
                                            sendComment={async () => { sendComment({ idChild: comment.id }) }}
                                            setComment={setComment}
                                        />
                                    )
                                }
                            </Box>
                        )}
                        description={(
                            <Box sx={styles.description}>
                                {
                                    comment?.comments?.map((comment, index) => (<CommentDetail notAddComment={!existed} comment={comment} index={index} />))
                                }
                                {
                                    comment?.comments?.length===0  && <Typography variant="subtitle_grey">{t('schedule.errors.noComments')}</Typography>
                                }
                            </Box>
                        )}
                    />
                </>)
            }
        </ActionDrawer>
    )
}

export { Comment }
